import { render, staticRenderFns } from "./RelationshipRentCreateUpdate.vue?vue&type=template&id=1b895226&scoped=true&"
import script from "./RelationshipRentCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./RelationshipRentCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./RelationshipRentCreateUpdate.vue?vue&type=style&index=0&id=1b895226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b895226",
  null
  
)

export default component.exports